// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");
var Selection__InputSelection$SmartcutsMacros = require("./Selection__InputSelection.bs.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("../DomElementIdentifierGenerator.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("../DomElementIdentifierPaired__WithSelector.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "start",
                Decco.intToJson(v.start)
              ],
              [
                "end_",
                Decco.intToJson(v.end_)
              ],
              [
                "selectionDirection",
                Selection__InputSelection$SmartcutsMacros.SelectionDirection.t_encode(v.selectionDirection)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var start = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start"), null));
  if (start.TAG === /* Ok */0) {
    var end_ = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_"), null));
    if (end_.TAG === /* Ok */0) {
      var selectionDirection = Selection__InputSelection$SmartcutsMacros.SelectionDirection.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selectionDirection"), null));
      if (selectionDirection.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  start: start._0,
                  end_: end_._0,
                  selectionDirection: selectionDirection._0
                }
              };
      }
      var e = selectionDirection._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".selectionDirection" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = end_._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".end_" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = start._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".start" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var InputSelectionParams = {
  t_encode: t_encode,
  t_decode: t_decode
};

function params_encode(v) {
  if (typeof v === "number") {
    return ["SelectionNotSupported"];
  } else if (v.TAG === /* InputSelectionParams */0) {
    return [
            "InputSelectionParams",
            t_encode(v._0)
          ];
  } else {
    return [
            "InputCursorPosition",
            Decco.intToJson(v._0)
          ];
  }
}

function params_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "InputCursorPosition" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputCursorPosition */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "InputSelectionParams" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputSelectionParams */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SelectionNotSupported" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SelectionNotSupported */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode$1(encoder_domElementRepresentation, v) {
  return Js_dict.fromArray([
              [
                "domElementRepresentation",
                Curry._1(encoder_domElementRepresentation, v.domElementRepresentation)
              ],
              [
                "params",
                params_encode(v.params)
              ],
              [
                "value",
                Decco.stringToJson(v.value)
              ]
            ]);
}

function t_decode$1(decoder_domElementRepresentation, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var domElementRepresentation = Curry._1(decoder_domElementRepresentation, Belt_Option.getWithDefault(Js_dict.get(dict$1, "domElementRepresentation"), null));
  if (domElementRepresentation.TAG === /* Ok */0) {
    var params = params_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "params"), null));
    if (params.TAG === /* Ok */0) {
      var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
      if (value.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  domElementRepresentation: domElementRepresentation._0,
                  params: params._0,
                  value: value._0
                }
              };
      }
      var e = value._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".value" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = params._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".params" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = domElementRepresentation._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".domElementRepresentation" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var Generic = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  return t_encode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, v);
}

function t_decode$2(v) {
  return t_decode$1(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, v);
}

function fromHtmlInputElement(domElementIdentifierGenerator, htmlInputElement) {
  var selector = Selector$SmartcutsMacros.forDomElement(htmlInputElement);
  var value = htmlInputElement.value;
  var start = htmlInputElement.selectionStart;
  var end_ = htmlInputElement.selectionEnd;
  var params;
  if (start === end_) {
    params = {
      TAG: /* InputCursorPosition */1,
      _0: start
    };
  } else {
    var selectionDirection = Selection__InputSelection$SmartcutsMacros.SelectionDirection.fromString(htmlInputElement.selectionDirection);
    params = {
      TAG: /* InputSelectionParams */0,
      _0: {
        start: start,
        end_: end_,
        selectionDirection: selectionDirection
      }
    };
  }
  var domElementIdentifier = DomElementIdentifierGenerator$SmartcutsMacros.identifierForElement(htmlInputElement, domElementIdentifierGenerator);
  return {
          domElementRepresentation: {
            domElementIdentifier: domElementIdentifier,
            selector: selector
          },
          params: params,
          value: value
        };
}

var ForRecording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromHtmlInputElement: fromHtmlInputElement
};

function t_encode$3(v) {
  return t_encode$1(Selector$SmartcutsMacros.selector_encode, v);
}

function t_decode$3(v) {
  return t_decode$1(Selector$SmartcutsMacros.selector_decode, v);
}

function fromRecording(selectionOrCursor) {
  return {
          domElementRepresentation: selectionOrCursor.domElementRepresentation.selector,
          params: selectionOrCursor.params,
          value: selectionOrCursor.value
        };
}

function updateSelector(f, param) {
  return {
          domElementRepresentation: Curry._1(f, param.domElementRepresentation),
          params: param.params,
          value: param.value
        };
}

var ForNonRecording = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromRecording: fromRecording,
  updateSelector: updateSelector
};

var SelectionDirection;

exports.SelectionDirection = SelectionDirection;
exports.InputSelectionParams = InputSelectionParams;
exports.params_encode = params_encode;
exports.params_decode = params_decode;
exports.Generic = Generic;
exports.ForRecording = ForRecording;
exports.ForNonRecording = ForNonRecording;
/* Selector-SmartcutsMacros Not a pure module */
